(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oob-deals-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', async function(event) {
  const next = event.target.closest('[data-wd-next]');
  if (!next || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const catalog = next.closest('[data-wd-catalog]');
  if (!catalog || next.dataset.loading) return;
  event.preventDefault();
  next.dataset.loading = 'true';
  next.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(next.href);
    if (!response.ok) throw new Error('Page unavailable');
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const incoming = page.querySelector('[data-wd-grid]');
    if (!incoming) throw new Error('Catalog unavailable');
    const grid = catalog.querySelector('[data-wd-grid]');
    const known = new Set(Array.from(grid.querySelectorAll('[data-product-id]'), card => card.dataset.productId));
    let firstNew;
    incoming.querySelectorAll('[data-product-id]').forEach(card => {
      if (!known.has(card.dataset.productId)) { grid.appendChild(card); firstNew = firstNew || card.querySelector('a'); }
    });
    const following = page.querySelector('[data-wd-next]');
    if (following) next.href = following.href;
    else next.parentElement.remove();
    if (firstNew) firstNew.focus({preventScroll: true});
  } catch (_) { window.location.assign(next.href); }
  finally { delete next.dataset.loading; next.removeAttribute('aria-busy'); }
});

  } catch(e) { console.error(e); }
})();
})();
